import Navbar from 'components/navbar';
import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react';
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';

const OOCFdpHoc = () => {
  const {
    OOCStore: { resetStore },
  } = useStore();

  useEffect(() => {
    return () => {
      resetStore();
    };
  }, [resetStore]);

  return (
    <div>
      <Navbar heading="FDP - Out of Cycle" />
      <Outlet />
    </div>
  );
};

export default observer(OOCFdpHoc);
